module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dictionaries":{"id":"ID","code":"Code","name":"Name","title":"Dictionaries"}},"ru":{"dictionaries":{"id":"ID","code":"Код","name":"Наименование","title":"Справочники"}}}')
  delete Component.options._Ctor
}
